import React from "react";

import { StyledStartButt } from './styles/StyledButt'

export default ({ callback }) => <StyledStartButt onClick={callback}>Start Game</StyledStartButt>;
